import { Row, Col, Button, Card, Form } from 'react-bootstrap';
import Header from "../../components/ChooseSection/Navbar/Header";
import Footer from "../../components/Footer/Footer";
import React, { useState, useEffect, useRef } from 'react'
import { useForm } from 'react-hook-form';
import * as yup from "yup";

import { useLocation, useNavigate } from 'react-router-dom'
const schema = yup.object().shape({



});

const SuccessPage = () => {

    const navigate = useNavigate()
    const location = useLocation()
    const { name, transactionNumber, amount } = location.state || {}
    console.log("Received from location.state ->", name, transactionNumber, amount);


    return (
        <div className="student-page">
            <Header />
            <header className="height-75">
                <div className="container h-100 d-flex flex-column align-items-center justify-content-center text-light">
                    <h1 className="text-center fw-semibold">Success</h1>
                </div>
            </header>

            <section className="teacher-section py-3 bg_img ">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            {/* <div className="section-header">
                                <h3 className="title"><b>S</b></h3>
                            </div> */}
                        </div>
                    </div>
                    <div className="cart-checkout-box mb-widget"></div>
                    <Card className="text-center">
                        <Card.Header>
                            <h4 className="text-success">Payment Successful</h4>
                        </Card.Header>
                        <Card.Body>
                            <p className="fs-5">Thank you </p>
                            <p>Your payment of <strong>{amount}</strong> has successful</p>
                            {/* <p><strong>Transaction ID:</strong> {transactionNumber}</p> */}
                            {/* <Button color="primary" onClick={() => navigate('/dashboard')}>
                                Go to Dashboard
                            </Button> */}
                        </Card.Body>
                    </Card>




                </div>
            </section >
            <Footer />
        </div >
    );
}
export default SuccessPage;